module.exports = __webpack_public_path__ + "img/tui.0b59c592.png";